import CareerDesignCenter from './CareerDesignCenter'

export default CareerDesignCenter
